import { getValidAccessToken, refreshAccessToken, AuthExpiredError } from "./auth";

const BASE_URL = "https://prod-api-v2.chlk.football";

class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

export { ApiError };

export async function apiFetch<T>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  let token = await getValidAccessToken();

  const makeRequest = (t: string) =>
    fetch(`${BASE_URL}${path}`, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${t}`,
        ...(options.headers ?? {}),
      },
    });

  let resp = await makeRequest(token);

  if (resp.status === 401) {
    // Refresh once and retry
    try {
      token = await refreshAccessToken();
      resp = await makeRequest(token);
    } catch {
      throw new AuthExpiredError();
    }
  }

  if (!resp.ok) {
    const body = await resp.text().catch(() => "");
    throw new ApiError(resp.status, body || `HTTP ${resp.status}`);
  }

  return resp.json() as Promise<T>;
}
